import snackBar from "src/utilities/snackBar/SnackBar"
import PortalRoleAndAssignmentTypes from "../types/portalRoleTypes/PortalRoleAndAssignmentTypes"

const removeDuplicateTargets = (raa: PortalRoleAndAssignmentTypes): PortalRoleAndAssignmentTypes => {
    const oldAssignmentList = raa.Assignments
    let cleanedAssignmentList = []
    let takenTargets: string[] = []
    for (let i = 0; i < oldAssignmentList.length; i++) {
        const target = oldAssignmentList[i].Target
        if (target && !takenTargets.includes(target)) {
            cleanedAssignmentList.push(oldAssignmentList[i])
            takenTargets.push(target)
        }
    }

    if(oldAssignmentList.length !== cleanedAssignmentList.length){
        snackBar({ type: "plain", text: "Removed duplicate targets", timeout: 5000 })
    }

    return {
        Role: raa.Role,
        Assignments: cleanedAssignmentList
    }
}

export default removeDuplicateTargets